export const CONFIRM_ZOOM_OAUTH_AUTHORIZATION_SUCCESS = 'CONFIRM_ZOOM_OAUTH_AUTHORIZATION_SUCCESS';

export const CONFIRM_STRIPE_OAUTH_AUTHORIZATION_SUCCESS = 'CONFIRM_STRIPE_OAUTH_AUTHORIZATION_SUCCESS';

export const GET_PREVIEW_EVENT_SUCCESS = 'GET_PREVIEW_EVENT_SUCCESS';

export const GET_PREVIEW_ORGANIZATION_SUCCESS = 'GET_PREVIEW_ORGANIZATION_SUCCESS';

export const SET_ADMIN_AUTH_TOKEN = 'SET_ADMIN_AUTH_TOKEN';
